import { Button, Tooltip } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (file: File) => void;
}

const ImageUploader = ({ onChange }: Props) => {
  const { t } = useTranslation();
  const [fileName, setFileName] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onChange(file);
      setFileName(file.name);
    }
  };
  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <>
      <Tooltip
        title={`${t('supported_image_file_formats_caption')}: .jpeg,.jpg,.svg,.png`}
        placement="top"
        arrow
      >
        <Button
          variant="contained"
          component="label"
          onClick={handleClick}
        >
          {fileName ? fileName.slice(0, 25) : t('upload_caption')}
        </Button>
      </Tooltip>
      <input
        hidden
        ref={inputRef}
        type="file"
        accept=".jpeg,.jpg,.svg,.png"
        onChange={handleChange}
      />
    </>
  );
};

export default ImageUploader;
